import HouseholdSettingsPortal from './HouseholdSettingsPortal'

export default HouseholdSettingsPortal